import React from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import { GridBlock } from '../../../../blocks'
import WatermarkFile from './fields/watermark-file'
import WatermarkPreview from './fields/watermark-preview'
import WatermarkPosition from './fields/watermark-position'

const FIELDS = [
    CreationToolSuperCutField.WatermarkFile,
    // TODO: Uncomment once we figure out how to store previous watermarks long-term.
    // CreationToolSuperCutField.WatermarkPreview,
    // CreationToolSuperCutField.WatermarkPosition,
]

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

const CreationCaptureInfoWatermark = () => {
    const fieldComponents = FIELDS.map(field => {
        switch (field) {
            case CreationToolSuperCutField.WatermarkFile:
                return WatermarkFile
            case CreationToolSuperCutField.WatermarkPreview:
                return WatermarkPreview
            case CreationToolSuperCutField.WatermarkPosition:
                return WatermarkPosition
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={FIELDS[i]} field={FIELDS[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoWatermark
